module.exports = __webpack_public_path__ + "img/step2.e587fb67.png";